/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_mapa': {
    width: 16,
    height: 16,
    viewBox: '0 0 17.667 17.667',
    data: '<g _fill="#fff"><path pid="0" data-name="Path 16822" d="M0 5.556h5.544v6.556H0zm0 0"/><path pid="1" data-name="Path 16823" d="M12.123 0h5.544v12.112h-5.544zm0 0"/><path pid="2" data-name="Path 16824" d="M6.579 0h4.509v8.316H6.579zm0 0"/><path pid="3" data-name="Path 16825" d="M6.579 9.351h4.509v8.316H6.579zm0 0"/><path pid="4" data-name="Path 16826" d="M0 0h5.544v4.52H0zm0 0"/><path pid="5" data-name="Path 16827" d="M12.123 13.147h5.544v4.52h-5.544zm0 0"/><path pid="6" data-name="Path 16828" d="M0 13.147h5.544v4.52H0zm0 0"/></g>'
  }
})
